<template>
  <div>
    <div class="demo-upload-list" v-for="item in uploadList">

      <template v-if="item.status === 'finished'">
        <Icon type="ios-backspace-outline" @click.native="handleRemove(item)"></Icon>
        <viewer :images="item | formateUrlArr" class="pics">
          <img :src="item | formateUrl">
        </viewer>
        <!-- <div class="demo-upload-list-cover">
	               <Icon type="ios-eye-outline" @click.native="handleView(item.name)"></Icon>
	               <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
	           </div> -->
      </template>
      <template v-else>
        <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
      </template>
    </div>
    <Upload v-show='maxLen > uploadList.length' ref="upload" :show-upload-list="false" :default-file-list="defaultList"
      :on-success="handleSuccess" :format="['jpg', 'jpeg', 'png']" :max-size="2048" :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" :data="extradata" multiple type="drag"
      :action="actionUrl" style="display: inline-block;width:58px;">
      <div style="width: 58px;height:58px;line-height: 58px;">
        <Icon type="ios-camera" size="20"></Icon>
      </div>
    </Upload>
    <!-- <Modal title="View Image" v-model="visible">
	       <img :src="'https://o5wwk8baw.qnssl.com/' + imgName + '/large'" v-if="visible" style="width: 100%">
	   </Modal> -->
  </div>
</template>
<script>
export default {
  name: 'upImg',
  watch: {
    datanum: {
      deep: true,
      handler: function (newval, oldval) {

        if (this.defaultimg == '') {
          this.$refs.upload.fileList = this.uploadList = []
        }
      }
    },
    defaultimg: {
      immediate: true,
      deep: true,
      handler: function (newval, oldval) {
        //console.log(newval,oldval)
        var that = this
        that.$nextTick(() => {
          if (newval && newval != '') {
            var arr = newval.split(",")
            var newarr = []
            for (var i = 0; i < arr.length; i++) {
              var ojb = {
                percentage: 100,
                showProgress: false,
                status: 'finished',
                response: {
                  url: arr[i] + '@' + arr[i]
                }
              }
              newarr.push(ojb)
            }

            that.$refs.upload.fileList = that.uploadList = newarr
          } else {
            that.$refs.upload.fileList = that.uploadList = []
          }
        })


        // this.defaultList = [
        //   {'name':'',percentage: 100,showProgress: false,status: "finished",response:{url:newval+'@'+newval,success: true,error:0,data:{file:newval+'@'+newval}},}
        // ]
      }
    },
    //  defaultimg2:function (newval,oldval){
    //      //console.log(newval,'-----》')
    //       //console.log(oldval,'---old--》')
    //       var that = this
    //      if(newval&&newval!=''){
    //        var arr  = newval.split(",")
    //         var newarr = []
    //         for(var i=0;i<arr.length;i++){
    //             var ojb = {
    //                 percentage:100,
    //                 showProgress:false,
    //                 status:'finished',
    //                 response:{
    //                   url:arr[i]+'@'+arr[i]
    //                 }
    //             }
    //             newarr.push(ojb)
    //         }
    //        //console.log(newarr,'newarr')
    //        that.$refs.upload.fileList =  that.uploadList = newarr
    //      }else{
    //         that.$refs.upload.fileList = that.uploadList = []
    //      }


    // }
  },
  props: {
    datanum: {
      type: Number,
    },
    maxLen: {
      type: Number,
      default: 1
    },
    defaultimg: {
      type: String,
      default: '',
    },
    extradata: {
      type: Object,
      default: {},
    },
    defaultname: {
      type: String,
      default: '',
    },
    defaultImgList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      defaultList: [],
      imgName: '',
      visible: false,
      uploadList: [],
      actionUrl: '',
    }
  },
  methods: {
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove (file) {
      const fileList = this.$refs.upload.fileList;

      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.$emit('upImglist', {
        pics: this.uploadList,
        name: this.defaultname
      })
    },
    handleSuccess (res, file) {
      this.$emit('upImglist', {
        pics: this.uploadList,
        name: this.defaultname
      })
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '图片格式不正确',
        desc: '图片' + file.name + ' 格式不正确.'
      });
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: 'Exceeding file size limit',
        desc: 'File  ' + file.name + ' is too large, no more than 2M.'
      });
    },
    handleBeforeUpload () {

      const check = this.uploadList.length < this.maxLen;
      if (!check) {
        this.$Notice.warning({
          title: '不能超过' + this.maxLen + '张图片'
        });
      }
      return check;
    }
  },
  mounted () {


    // var actionUrl = 'http://display.incich.com:9208/UploadImageServlet?ispress=1&thum=1&width=60&height=60&notkeeppic=1'
    // this.actionUrl = this.baseURL.imgURL + '?ispress=1&thum=1&width=60&height=60&notkeeppic=1'
    this.actionUrl = this.baseURL.imgURL
    this.uploadList = this.$refs.upload.fileList;


  },
  filters: {
    formateUrl (val, flag) {

      var item = val.response.url
      return item.split("@")[0]
    },
    formateUrlArr (val) {

      var item = val.response.url
      var arr = []
      arr.push(item.split("@")[0])

      return arr


    }
  }
}
</script>
<style scoped>
.demo-upload-list {

  display: inline-block;
  width: 98px;
  height: 55px;
  text-align: center;
  line-height: 60px;
  /*    border: 1px solid transparent; */
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
  margin-right: 4px;
}

.demo-upload-list .pics {
  width: 100%;
  height: 100%;
}

.demo-upload-list img {
  width: 100%;
  height: 100%;
  display: block;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.demo-upload-list .ivu-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 0 0 0 16px;
  color: #fff;
  cursor: pointer;
}
</style>
